import React from 'react';

const containsInstanceOf = (Type, children) => {
  let hasInstance = false;

  React.Children.forEach(children, (child) => {
    if (child && child.type === Type) {
      hasInstance = true;
    }
  });

  return hasInstance;
};

export default containsInstanceOf;
